
import { Component, ViewChild, Output, Input, EventEmitter } from '@angular/core';
import { ToolbarService, LinkService, ImageService, HtmlEditorService, RichTextEditorComponent, CountService } from '@syncfusion/ej2-angular-richtexteditor';
import { createElement, KeyboardEventArgs, removeClass, Browser } from '@syncfusion/ej2-base';
import { inputs } from '@syncfusion/ej2-angular-richtexteditor/src/rich-text-editor/richtexteditor.component';
@Component({
    selector: 'editor',
    templateUrl: './editor.component.html',
    providers: [ToolbarService, LinkService, ImageService, HtmlEditorService, CountService]
})
export class EditorComponent {
    public result:any;
    @ViewChild('mdPreview', { static: false })
    // public rteObj: RichTextEditorComponent;
    // public textArea: HTMLTextAreaElement;
    public mdsource: HTMLElement;
    public mdSplit: HTMLElement;
    public htmlPreview: HTMLElement;
    @Output() getData: any = new EventEmitter<any>();
    @Input() data: any;
    @Input() status;
    @ViewChild('toolsRTE', { static: false }) public rteObj: RichTextEditorComponent;
    @Input() index;
    public tools: object = {
        items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
            'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
            'LowerCase', 'UpperCase', '|',
            'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
            'Outdent', 'Indent', '|',
            'CreateLink', 'Image', '|', 'ClearFormat', 'FullScreen', '|', 'Undo', 'Redo']
    };
    public maxLength: number = 1000;
    public textArea: HTMLElement;
    public myCodeMirror: any;
    
    ngAfterViewInit(): void {
        let rteObj: RichTextEditorComponent = this.rteObj;
        this.appendData();

    }

    appendData() {
        if (this.rteObj) {
            let id: string = this.rteObj.getID() + '_rte-edit-view';
            let editView: HTMLElement = this.rteObj.element.querySelector('#' + id) as HTMLElement;
            editView.innerHTML = this.data === "" ? "<span style='color: rgb(89, 89, 89); text-decoration: inherit;'><em>Start Write Here<em></span>" : this.data;
        }
    }
    public mirrorConversion(e?: any): void {
        let id: string = this.rteObj.getID() + 'mirror-view';
        let mirrorView: HTMLElement = this.rteObj.element.querySelector('#' + id) as HTMLElement;
        let charCount: HTMLElement = this.rteObj.element.querySelector('.e-rte-character-count') as HTMLElement;
        if (e.targetItem === 'Preview') {
            this.textArea.style.display = 'block';
            mirrorView.style.display = 'none';
            this.textArea.innerHTML = this.myCodeMirror.getValue();
            charCount.style.display = 'block';
        } else {
            if (!mirrorView) {
                mirrorView = createElement('div', { className: 'e-content' });
                mirrorView.id = id;
                this.textArea.parentNode.appendChild(mirrorView);
            } else {
                mirrorView.innerHTML = '';
            }
            this.textArea.style.display = 'none';
            mirrorView.style.display = 'block';
            charCount.style.display = 'none';
        }
    }


    public actionCompleteHandler(e: any): void {
        if (e.targetItem && (e.targetItem === 'SourceCode' || e.targetItem === 'Preview')) {
            (this.rteObj.sourceCodeModule.getPanel() as HTMLTextAreaElement).style.display = 'none';
            this.mirrorConversion(e);
        } else {
            let rteObj: RichTextEditorComponent = this.rteObj;
            this.result=rteObj.contentModule.getEditPanel();
            this.getData.emit(rteObj.contentModule.getEditPanel());
            setTimeout(() => { this.rteObj.toolbarModule.refreshToolbarOverflow(); }, 400);
        }
    }

    public onCreate() {
        this.textArea = this.rteObj.contentModule.getEditPanel() as HTMLTextAreaElement;

        this.textArea.addEventListener('keyup', (e: KeyboardEventArgs) => {
            let rteObj: RichTextEditorComponent = this.rteObj;
            this.result=rteObj.contentModule.getEditPanel();

            this.getData.emit(rteObj.contentModule.getEditPanel());
        });
    }

    ngOnChanges(): void {
        if(this.status=='click')
        this.appendData();
    }
}